import { useQuery } from '@tanstack/react-query';
import { patientCareTeamNextAppointments } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const usePatientCareTeamNextAppointmentsQuery = (patientId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'patient-care-team-next-sessions', patientId ], async () => {
    const response = await patientCareTeamNextAppointments(patientId);

    return response.data;
  }, opts);
};
